import { render, staticRenderFns } from "./ai-memory-usage-dialog.vue?vue&type=template&id=68d788bf&scoped=true&"
import script from "./ai-memory-usage-dialog.vue?vue&type=script&lang=js&"
export * from "./ai-memory-usage-dialog.vue?vue&type=script&lang=js&"
import style0 from "./ai-memory-usage-dialog.vue?vue&type=style&index=0&id=68d788bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d788bf",
  null
  
)

export default component.exports